export type SortDirection = 'asc' | 'desc' | null;

/** Sortable column label with a 3-state cycle indicator (asc → desc → none). */
export function SortableHeader({
  label,
  sortKey,
  currentSort,
  currentDirection,
  onSort,
}: {
  label: string;
  sortKey: string;
  currentSort: string | null;
  currentDirection: SortDirection;
  onSort: (key: string) => void;
}) {
  const isActive = currentSort === sortKey;
  return (
    <button type="button" className={`sortable${isActive ? ' active' : ''}`} onClick={() => onSort(sortKey)}>
      <span>{label}</span>
      {isActive && currentDirection === 'asc' ? (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round">
          <path d="m18 15-6-6-6 6" />
        </svg>
      ) : isActive && currentDirection === 'desc' ? (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round">
          <path d="m6 9 6 6 6-6" />
        </svg>
      ) : (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" opacity={0.5}>
          <path d="m21 16-4 4-4-4M17 20V4M3 8l4-4 4 4M7 4v16" />
        </svg>
      )}
    </button>
  );
}
